<template>
  <v-row class="my-10">
    <v-col class="align-self-center text-center">
      <p class="appkit-subheading">Download a template</p>
      <div class="button-container">
        <PIconButton v-if="authenticationStore.canDownloadCustomerExcelTemplate()"
          appkit-icon="icon-download-cloud-outline" href="/static/supplier-template-customer.xlsx">
          Excel
        </PIconButton>
        <PIconButton v-else appkit-icon="icon-download-cloud-outline" href="/static/supplier-template-supplier.xlsx">
          Excel
        </PIconButton>
        <PIconButton v-if="authenticationStore.canDownloadCustomerExcelTemplate()"
          appkit-icon="icon-download-cloud-outline" href="/static/supplier-template-customer.csv">
          CSV
        </PIconButton>
        <PIconButton v-else appkit-icon="icon-download-cloud-outline" href="/static/supplier-template-supplier.csv">
          CSV
        </PIconButton>
      </div>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import PIconButton from "@/components/custom/buttons/PIconButton.vue";
import { useAuthenticationStore } from "@/stores/authentication";

const authenticationStore = useAuthenticationStore();
</script>
